module.exports = __webpack_public_path__ + "static/img/28.6579319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/28.jpg
// module id = TD5y
// module chunks = 0